








































































































































































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { DateHelper } from '@/modules/shared/helpers/date'
import dayjs from 'dayjs'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import { ContentItemUpdatableAttributesResourceModel } from '@/modules/content-item/models/content-item-resource.model'
import {
  AdminContentItemGetUpdatableAttributesUseCase
} from '@/modules/content-item/use-cases/admin/admin-content-item-get-updatable-attributes.use-case'
import {
  AdminContentItemUpdateAttributesUseCase
} from '@/modules/content-item/use-cases/admin/admin-content-item-update-attributes.use-case'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import TagsInput from '@/modules/shared/components/shared/kit/TagsInput.vue'
import { InputHelper } from '@/modules/shared/helpers/input'
import AdminContentManagerSearch from '@/modules/user/components/admin/AdminContentManagerSearch.vue'

@Component({
  components: {
    AdminContentManagerSearch,
    CurrencyInput,
    Toggle,
    BaseInput,
    BaseSelect,
    Modal,
    BaseButton,
    TagsInput
  }
})
export default class AdminContentItemUpdateAttributes extends Vue {
  @Prop({ required: true }) contentItemId!: number
  @Prop({ default: 'تنظیمات' }) label?: string

  contentItemAttributes: ContentItemUpdatableAttributesResourceModel = null

  dialogModel: boolean = false

  // $refs!: {
  //   refPopupDeliveredAt: QPopupProxy,
  //   refPopupCompletedAt: QPopupProxy,
  // }

  constructor(
    private readonly adminContentItemService: AdminContentItemService,
    private readonly dateHelper: DateHelper,
    private readonly updateAttributesUseCase: AdminContentItemUpdateAttributesUseCase,
    private readonly getAttributesUseCase: AdminContentItemGetUpdatableAttributesUseCase
  ) {
    super()
  }

  //-----------------------------computed
  get keywordCounts(): number {
    const keywords = this.contentItemAttributes.keywords
    return !!keywords ? keywords.length : 0
  }

  get contentItemWordCounts() {
    return this.getAttributesUseCase.allData.word_counts
  }

  get contentItemStatuses() {
    return this.getAttributesUseCase.allData.statuses
  }

  get contentItemContentTypes() {
    return this.getAttributesUseCase.allData.content_types
  }

  get contentItemTones() {
    return this.getAttributesUseCase.allData.tones
  }

  get wordCountsOptions() {
    return InputHelper.convertToOptions(this.contentItemWordCounts)
  }

  get contentTypesOptions() {
    return InputHelper.convertToOptions(this.contentItemContentTypes)
  }

  get statusOptions() {
    return InputHelper.convertToOptions(this.contentItemStatuses)
  }

  get tonesOptions() {
    return InputHelper.convertToOptions(this.contentItemTones)
  }

  get deliveredAt() {
    return this.contentItemAttributes.deliver_at ?
      this.getJalaliDate(this.contentItemAttributes.deliver_at) : ''
  }

  set deliveredAt(value) {
    this.contentItemAttributes.deliver_at = this.jalaliToGregory(value)
  }

  get completedAt() {
    return this.contentItemAttributes.completed_at ?
      this.getJalaliDate(this.contentItemAttributes.completed_at) : ''
  }

  set completedAt(value) {
    this.contentItemAttributes.completed_at = this.jalaliToGregory(value)
  }

  get sentToQueueAt() {
    return this.contentItemAttributes.sent_to_queue_at ?
      this.getJalaliDate(this.contentItemAttributes.sent_to_queue_at) : ''
  }

  set sentToQueueAt(value) {
    this.contentItemAttributes.sent_to_queue_at = this.jalaliToGregory(value)
  }

  //-------------------------------methods
  //-------------------should be in date component
  jalaliToGregory(value) {
    return value ? this.dateHelper.fromJalali(value).toTimestamp() : null
  }

  getJalaliDate(value) {
    return dayjs(value).format('YYYY/MM/DD')
  }

  //------------------------------------------------

  fetchContentItemAttributes() {
    this.getAttributesUseCase.execute(this.contentItemId).then((resp) => {
      if (resp.isSuccess()) {
        this.dialogModel = true
        this.contentItemAttributes = this.getAttributesUseCase.data
      }
    })
  }

  updateContentItemAttributes() {
    this.updateAttributesUseCase.execute(this.contentItemId, this.contentItemAttributes)
      .then(() => {
        if (this.updateAttributesUseCase.isSuccess) {
          this.dialogModel = false
        }
      })
  }
}
